module.exports = __webpack_public_path__ + "static/media/close-dialog-x.e8248cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/close-dialog-x.png
// module id = 601
// module chunks = 0